import GrtLoading from '@/components/GrtLoading/GRTLoading';
import { useEffect, useState } from 'react';
import { oauthTokenLogin } from '@/api/login';
import withRouter from '@/components/withRouter';
import { updateCookie } from '@/utils/index';
import Toast from '@/components/Toast';
import NoAuth from '@/components/noAuth';

//3.0
const OauthTokenLogin = (props) => {
    let token = props.searchParams.get('token'),
        third_code = props.searchParams.get('third_code'),
        redirect = props.searchParams.get('redirect');
    const [isAuthorized, setIsAuthorized] = useState(true);
    const thirdLogin = async () => {
        try {
            let data = {
                    third_code: third_code || 'chetc',
                    token: token
                },
                res = await oauthTokenLogin(data);
            if (res?.code === 'A0146') {
                setIsAuthorized(false);
                return;
            }
            if (res && res.success) {
                updateCookie(Object.assign(res.data, { domain: window.location.host }));
                let { protocol, host } = window.location; //跳到问卷
                if (redirect) {
                    window.location.href = redirect;
                } else {
                    window.location.href = `${protocol}//${host}/operate/manage/schemeConfigPage/110`;
                }
                setIsAuthorized(true);
            } else {
                Toast.error(res.msg || '登录失败');
            }
            setIsAuthorized(true);
        } catch (e) {
            setIsAuthorized(true);
        }
    };
    useEffect(() => {
        if (token) {
            thirdLogin();
        }
    }, [token]);
    return (
        <div style={{ height: window.innerHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {isAuthorized ? <GrtLoading></GrtLoading> : <NoAuth />}
        </div>
    );
};

export default withRouter(OauthTokenLogin);
